import type { SessionSlot } from '@features/customization-session/types';

import { Info } from 'lucide-react';

import { Popover, PopoverContent, PopoverTrigger } from '@shared/components/ui/popover';

type Props = {
  slot: Pick<SessionSlot, 'order' | 'orderId' | 'externalOrder' | 'externalOrderId'>;
};

/** The order of a product: its references inline, every identifier on click (selectable, to copy them). */
export const OrderDetails = ({ slot }: Props) => {
  const rows: [string, string | number | null][] = [
    ['ID', slot.orderId],
    ['Référence', slot.order],
    ['ID externe', slot.externalOrderId],
    ['Référence externe', slot.externalOrder],
  ];

  return (
    <Popover>
      <PopoverTrigger
        aria-label={`Détails de la commande ${slot.order}`}
        className="inline-flex min-w-0 cursor-pointer items-center gap-1 rounded-sm underline decoration-dotted underline-offset-2 hover:text-foreground focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none"
      >
        <span className="truncate">{slot.order}</span>
        <Info aria-hidden className="size-3.5 shrink-0" />
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto min-w-64">
        <p className="mb-2 text-sm font-bold">Commande</p>
        <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-sm">
          {rows.map(([label, value]) => (
            <div className="contents" key={label}>
              <dt className="text-muted-foreground">{label}</dt>
              <dd className="font-mono tabular-nums select-all [overflow-wrap:anywhere]">{value ?? '—'}</dd>
            </div>
          ))}
        </dl>
      </PopoverContent>
    </Popover>
  );
};
